import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import FormActionButtons from "../../../components/Button/FormActionButtons";



const AddTransaksiSingkong = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const editIndex = searchParams.get("index");
  const isEdit = editIndex !== null && !isNaN(editIndex);

  const [formData, setFormData] = useState({
    NoNota: "",
    KodeReferensi: "",
    TanggalNota: "",
    TanggalVerifikasi: "",
    IdAngkutan: "",
    NoKendaraan: "",
    Supplier: "",
    JenisVarietes: "",
    KadarAci: "",
    Gross: "",
    Tare: "",
    Netto: "",
    Refraksi: "",
    BeratBersih: "", // ✅ diperbaiki dari 'beratbersih'
    harga: "",
    PBongkarSPM: "",
    TotalHargaSPM: "",
    PBongkarSTN: "",
    TotalHargaSTN: "",
    KomisiGrossPerKG: "",
    KomisiGross: "",
    PremiPerKG: "",
    Premi: "",
    LpPerKG: "",
    LoyaltyPts: "",
    KomisiBersih: "",
    StatusTransaksi: "",
    DitambahkanOleh: "",
    DiubahOleh: "",
  });

  useEffect(() => {
    if (isEdit) {
      const existing = JSON.parse(localStorage.getItem("transaksiSingkong")) || [];
      const index = parseInt(editIndex, 10);
      const data = existing[index];

      if (data) {
        setFormData((prev) => ({ ...prev, ...data }));
      } else {
        alert("Data tidak ditemukan");
        navigate("/transaksi-singkong");
      }
    }
  }, [isEdit, editIndex, navigate]);
  const handleCancel = () => {
  navigate("/transaksi-singkong");
};



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = useCallback(
  (e) => {
    if (e?.preventDefault) e.preventDefault();

    const existing = JSON.parse(localStorage.getItem("transaksiSingkong")) || [];

    if (isEdit) {
      existing[editIndex] = formData;
      alert("Transaksi berhasil diubah!");
    } else {
      existing.unshift(formData);
      alert("Transaksi berhasil ditambahkan!");
    }

    localStorage.setItem("transaksiSingkong", JSON.stringify(existing));
    navigate("/transaksi-singkong");
  },
  [formData, isEdit, editIndex, navigate]
);


  const fields = [
    "NoNota",
    "KodeReferensi",
    "TanggalNota",
    "TanggalVerifikasi",
    "IdAngkutan",
    "NoKendaraan",
    "Supplier",
    "JenisVarietes",
    "KadarAci",
    "Gross",
    "Tare",
    "Netto",
    "Refraksi",
    "BeratBersih", // ✅ konsisten
    "harga",
    "PBongkarSPM",
    "TotalHargaSPM",
    "PBongkarSTN",
    "TotalHargaSTN",
    "KomisiGrossPerKG",
    "KomisiGross",
    "PremiPerKG",
    "Premi",
    "LpPerKG",
    "LoyaltyPts",
    "KomisiBersih",
    "StatusTransaksi",
    "DitambahkanOleh",
    "DiubahOleh",
  ];

  const labelMap = {
    NoNota: "No Nota",
    KodeReferensi: "Kode Referensi",
    TanggalNota: "Tanggal Nota",
    TanggalVerifikasi: "Tanggal Verifikasi",
    IdAngkutan: "ID Angkutan",
    NoKendaraan: "No Kendaraan",
    Supplier: "Supplier",
    JenisVarietes: "Jenis Varietes",
    KadarAci: "Kadar Aci",
    Gross: "Gross",
    Tare: "Tare",
    Netto: "Netto",
    Refraksi: "Refraksi",
    BeratBersih: "Berat Bersih",
    harga: "Harga",
    PBongkarSPM: "P. Bongkar SPM",
    TotalHargaSPM: "Total Harga SPM",
    PBongkarSTN: "P. Bongkar STN",
    TotalHargaSTN: "Total Harga STN",
    KomisiGrossPerKG: "Komisi Gross/KG",
    KomisiGross: "Komisi Gross",
    PremiPerKG: "Premi/KG",
    Premi: "Premi",
    LpPerKG: "LP/KG",
    LoyaltyPts: "Loyalty Pts",
    KomisiBersih: "Komisi Bersih",
    StatusTransaksi: "Status Transaksi",
    DitambahkanOleh: "Ditambahkan Oleh",
    DiubahOleh: "Diubah Oleh",
  };

  return (
    <div className="pl-64 mt-8">
  <form
    onSubmit={handleSubmit}
    className="max-w-3xl p-5 mx-auto bg-white border border-gray-200 shadow-lg rounded-2xl"
  >
    <h2 className="mb-5 text-lg font-semibold text-center text-gray-800 sm:text-xl">
      {isEdit ? "Edit Transaksi Singkong" : "Tambah Transaksi Singkong"}
    </h2>

    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      {fields.map((field) => (
        <div key={field}>
          <label className="block mb-1 text-sm font-medium text-gray-700">
            {labelMap[field]}
          </label>
          <input
            type={["TanggalNota", "TanggalVerifikasi"].includes(field) ? "date" : "text"}
            name={field}
            required
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
            value={formData[field]}
            onChange={handleChange}
          />
        </div>
      ))}
    </div>

    <FormActionButtons
  onCancel={handleCancel}
  onSubmit={handleSubmit}
  submitLabel={isEdit ? "Update Transaksi" : "Tambah Transaksi"}
  cancelLabel="Batal"
  showCancel={true}
  fullWidth={true}
/>


  </form>
</div>

  );
};

export default AddTransaksiSingkong;
